import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login } from '../services/api';
import toast from 'react-hot-toast';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(username, password);
      loginUser(res.data.access_token, res.data.user);
      toast.success(`Welcome back, ${res.data.user.name}!`);
      navigate('/');
    } catch (err) {
      toast.error('Invalid username or password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#f8f9fa',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#ffffff', border: '1px solid #dee2e6',
        borderRadius: 16, padding: 40, width: 380
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>💎</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#212529' }}>123 Crystal OMS</h1>
          <p style={{ color: '#6c757d', fontSize: 13, marginTop: 4 }}>Order Management System</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#6c757d', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Username</label>
            <input
              style={{ width: '100%', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: 8, padding: '10px 14px', color: '#212529', fontSize: 14, outline: 'none' }}
              value={username} onChange={e => setUsername(e.target.value)}
              placeholder="Enter username" autoFocus
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#6c757d', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Password</label>
            <input
              style={{ width: '100%', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: 8, padding: '10px 14px', color: '#212529', fontSize: 14, outline: 'none' }}
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>
          <button
            type="submit" disabled={loading}
            style={{ width: '100%', background: 'linear-gradient(135deg,#7c6af5,#c084fc)', border: 'none', borderRadius: 8, padding: '12px', color: '#fff', fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}